import { gsap } from 'gsap';
import { Container } from '../../odie';

import { IAnimation } from '../../lib/pattern/IAnimation';

// types
//-----------------------------------------------------------------------------
export type WobbleAnimationOptions = {
  target: Container;
};

/*
    wobble the target
*/
export class WobbleAnimation implements IAnimation {
  // fields
  //-------------------------------------------------------------------------
  // input
  private _target: Container;

  // init
  //-------------------------------------------------------------------------
  constructor(options: WobbleAnimationOptions) {
    // set fields
    this._target = options.target;
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(): Promise<void> {
    const target = this._target;
    gsap.killTweensOf(target);
    target.scaleX = 1;
    target.scaleY = 1;

    // animation extend
    await gsap
      .timeline()
      .to(target, {
        scaleX: 1.3,
        scaleY: 0.7,
        duration: 0.17,
        ease: 'power1.out',
      })
      .to(target, {
        scaleX: 0.8,
        scaleY: 1.2,
        duration: 0.13,
        ease: 'power1.inOut',
      })
      .to(target, { scaleX: 1, scaleY: 1, duration: 0.13, ease: 'power1.in' });
  }

  public stop() {}
}
